// Port of api/fuel/app/classes/controller/api/monty/buddies/insights.php
import Constants from 'offline/constants'
import Insights from 'offline/insights'
import { resolveOwner } from 'offline/api/monty'
import F from 'offline/filter/constants'

export default function(params) {
	if (!params.slug && params.name) params = Object.assign({}, params, { slug: params.name })

	var owner = resolveOwner(params, F.OWNER_BUDDIES)
	if (!owner) {
		return Promise.reject({ error: 'Owner not found in offline database', offline: true })
	}

	return Promise.resolve(Insights.generate(
		Constants.TYPE_BUDDIES,
		owner,
		params.section || false,
		params.insight || false,
		params.detail || false,
		params.filter || {},
		params
	))
}
